// extracted by mini-css-extract-plugin
export default {"all":"NotFound_all__9w-3A","center":"NotFound_center__txboW","fade-in":"NotFound_fade-in__ZFoOT","err-404":"NotFound_err-404__GUKEG"};